var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-foot"},[_c('footer',{staticClass:"footer"},[_c('img',{attrs:{"src":require("../assets/img/footer.png"),"alt":""}})]),_c('div',{staticClass:"copyright"},[_vm._v(" Copyright © 2021 杭州课房科技有限公司版权所有 "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v(" 浙ICP备14043930号-1 ")])])])
}]

export { render, staticRenderFns }